import { UserApiUserCreateRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const useUserCreateMutation = () =>
  useBaseMutation({
    mutationFn: (req: UserApiUserCreateRequest, config) =>
      appApiClient.userApi.userCreate(req, config),
  });
